import React, { memo } from "react";
import { DataTable, SearchPropTypes } from "MODULES/shared/components";
import { displayDecimal } from "LIB/formatters/number";
import { Link } from "react-router-dom";
import { dollars } from "LIB/formatters/currency";

const Table = memo(
  ({ label = "Company", results = [], isLoading, refresh }) => (
    <DataTable loading={isLoading} loadingRows={3} refresh={refresh}>
      <DataTable.Head>
        <th>{label}</th>
        <th># Line Items</th>
        <th>Amount ($)</th>
      </DataTable.Head>
      <DataTable.Body>
        {results.map(r => (
          <tr>
            <td>
              {r.uuid ? (
                <Link to={`/companies/${r.uuid}`}>
                  <span className={"text-orange"}>{r.name}</span>
                </Link>
              ) : (
                <span className={"text-orange"}>{r.name}</span>
              )}
            </td>
            <td>{displayDecimal(r.stat, 2)}</td>
            <td>{dollars(r.amount, 2)}</td>
          </tr>
        ))}
      </DataTable.Body>
    </DataTable>
  )
);

Table.propTypes = {
  ...SearchPropTypes
};

export default Table;



// WEBPACK FOOTER //
// ./app/modules/Admin/CompanyRankings/Table.jsx